import {
    buildOptionsFromDefault,
    deserialiseToJSON
} from '../../../../../api/HelperAPI';

type WaitlistResponse = 'accepted' | 'rejected' | 'dismissed';

export type PostWaitlistRequestBody = {
    data: {
        response: WaitlistResponse;
        offer_id: number;
        drawdown_amount?: string;
        rejection_reason?:
            | 'already_have_business_card'
            | 'dont_need_credit_card'
            | 'benefits_not_compelling'
            | 'prefer_flexi_loan'
            | 'other';
        rejection_reason_detail?: string;
    };
};

export const postCreditCardWaitlist = async (
    stateKey: string,
    body: PostWaitlistRequestBody
): Promise<void> => {
    const url = `/api/lending/edge/credit_card/waitlist/${stateKey}/`;

    const options = buildOptionsFromDefault(
        {
            method: 'POST',
            body: JSON.stringify(body)
        },
        {
            accept: 'application/json'
        } as any
    ) as RequestInit;

    // eslint-disable-next-line iwoca/prefer-lapi-client
    const response = await fetch(url, options);
    await deserialiseToJSON(response);
};
